import React from "react";
import { Download } from "lucide-react";
import { API_BASE } from "@/lib/api";

const ExportCard = ({ title, desc, href, filename }) => {
  const download = async () => {
    const token = localStorage.getItem("rieave.admin.token");
    const res = await fetch(href, { headers: { Authorization: `Bearer ${token}` } });
    const blob = await res.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url; a.download = filename; a.click();
    URL.revokeObjectURL(url);
  };
  return (
    <div className="rounded-2xl p-6 flex flex-col" style={{ background: "rgba(255,255,255,0.03)", border: "1px solid rgba(255,255,255,0.06)" }}>
      <div className="w-10 h-10 rounded-full flex items-center justify-center mb-4" style={{ background: "linear-gradient(135deg, #C9789A, #9B8FBF)" }}>
        <Download size={15} className="text-cream" />
      </div>
      <p className="font-cormorant text-xl text-cream leading-tight">{title}</p>
      <p className="text-sm text-cream/75 mb-4 flex-1">{desc}</p>
      <button
        onClick={download}
        className="self-start h-10 px-5 rounded-xl font-label text-[11px] uppercase tracking-[0.22em] text-cream"
        style={{ background: "linear-gradient(135deg, #C9789A, #9B8FBF)" }}
      >
        Download CSV
      </button>
    </div>
  );
};

const AdminReports = () => (
  <div data-testid="admin-reports-page">
    <p className="font-label text-[11px] uppercase tracking-[0.22em] text-rose/70 mb-1">Operations</p>
    <h1 className="font-hero text-3xl text-cream mb-2">Reports & export</h1>
    <p className="text-sm text-cream/75 mb-6 max-w-2xl">Download your commerce data for accounting, marketplaces, or offline analysis.</p>

    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <ExportCard
        title="Orders export"
        desc="All orders with customer details, items, totals and statuses."
        href={`${API_BASE}/admin/reports/orders.csv`}
        filename="rieave-orders.csv"
      />
      <ExportCard
        title="Products export"
        desc="Full product catalog — ideal for marketplace re-upload."
        href={`${API_BASE}/admin/reports/products.csv`}
        filename="rieave-products.csv"
      />
    </div>
  </div>
);

export default AdminReports;
